
import Vue from 'vue'
import SortedProductList from '@/pages/categories/components/SortedProductList.vue'
import { SORT_ORDER } from '@/pages/categories/const'

export default Vue.extend({
  components: {
    SortedProductList
  },
  props: {
    categoryId: {
      type: Number,
      required: true
    }
  },
  computed: {
    sortOrder(): { [key: string]: string } {
      return SORT_ORDER
    }
  }
})
